import Col from "components/ui-elements/Col";
import React from "react";
import ListCheckbox from "./ListCheckbox";
const ListCheckboxCol = (props) => {
  const { colsize, model, margin, ...rest } = props
  return (
    <Col size={colsize} model={model} margin={margin}>
      <ListCheckbox {...rest} margin={margin} />
    </Col>
  );
};

ListCheckboxCol.defaultProps = {
  colsize: 12,
  model: "md",
  margin: "mb-1"
}

export default ListCheckboxCol;